
import { PricingData } from '@/types/pricing';

export const pricingData: PricingData = {
  starter: {
    name: "Foundation",
    icon: "tent",
    displayPrice: "$179/month",
    billingSubtext: "Save 17% with annual billing",
    description: "Perfect for small camps or weekend retreats (up to 100 campers)",
    ctaText: "Start with Foundation",
    ctaAction: "lead_form",
    features: [
      "Up to 100 active campers",
      "Recipe and Menu Planning",
      "Basic Inventory Tracking",
      "Sysco CSV Order Generation",
      "1 Admin + 3 Staff Accounts",
      "Email support"
    ]
  },
  premium: {
    name: "Professional",
    icon: "campfire",
    displayPrice: "$279/month",
    billingSubtext: "Save 17% with annual billing",
    description: "For growing camps managing multiple sessions and larger staff (up to 500 campers)",
    popular: true,
    ctaText: "Start with Professional",
    ctaAction: "lead_form",
    features: [
      "Everything in Foundation",
      "Up to 500 active campers",
      "Advanced Inventory Analytics",
      "Auto Sysco Sync & Reorder Reports",
      "Team Collaboration Tools",
      "Custom Menu Templates",
      "Up to 10 Staff Accounts",
      "Priority email support"
    ]
  },
  enterprise: {
    name: "Enterprise",
    icon: "mountain",
    displayPrice: "Custom Pricing",
    description: "For multi-site or year-round camps with complex operations",
    ctaText: "Contact Sales",
    ctaAction: "contact_sales",
    features: [
      "Unlimited Campers & Locations",
      "Full Sysco Integration (SFTP / EDI)",
      "Priority Support & Dedicated Onboarding",
      "API & Multi-Org Management",
      "Role-Based Access Controls",
      "Dedicated account manager"
    ]
  }
};
